import { render } from "./CallConfigSettings.vue?vue&type=template&id=5d685b62"
import script from "./CallConfigSettings.vue?vue&type=script&lang=js"
export * from "./CallConfigSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__